import React from 'react';

const styles = {
  page: {
    fontFamily: 'Arial, sans-serif',
    fontSize: '11px',
    color: '#1a1a1a',
    width: '148mm',
    minHeight: '210mm',
    padding: '8mm',
    boxSizing: 'border-box',
    backgroundColor: '#fff'
  },
  header: { textAlign: 'center', borderBottom: '2px solid #1976d2', paddingBottom: '8px', marginBottom: '12px' },
  orgName: { fontSize: '16px', fontWeight: 'bold', color: '#1976d2', margin: 0 },
  orgSub: { fontSize: '11px', color: '#555', margin: '2px 0' },
  receiptTitle: { fontSize: '13px', fontWeight: 'bold', margin: '6px 0 0', textTransform: 'uppercase', letterSpacing: '1px', color: '#333' },
  section: { marginBottom: '10px' },
  row: { display: 'flex', justifyContent: 'space-between', marginBottom: '4px' },
  label: { color: '#666', minWidth: '120px' },
  value: { fontWeight: '500', textAlign: 'right' },
  divider: { borderTop: '1px dashed #ccc', margin: '8px 0' },
  amountBox: { background: '#e8f5e9', border: '1px solid #4caf50', borderRadius: '4px', padding: '8px 12px', textAlign: 'center', margin: '10px 0' },
  amountLabel: { fontSize: '10px', color: '#388e3c', marginBottom: '2px' },
  amountValue: { fontSize: '20px', fontWeight: 'bold', color: '#1b5e20' },
  balanceBox: { background: '#fff8e1', border: '1px solid #ff9800', borderRadius: '4px', padding: '6px 12px', textAlign: 'center', margin: '6px 0' },
  balanceLabel: { fontSize: '10px', color: '#e65100' },
  balanceValue: { fontSize: '14px', fontWeight: 'bold', color: '#bf360c' },
  footer: { textAlign: 'center', borderTop: '1px solid #eee', paddingTop: '8px', marginTop: '12px', fontSize: '10px', color: '#999' }
};

function PaymentReceipt({ payment, bill }) {
  const balanceDue = parseFloat(bill.total_amount) - parseFloat(bill.amount_paid);
  const isPaidFull = balanceDue <= 0;

  return (
    <div style={styles.page}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', borderBottom: '2px solid #2e7d32', paddingBottom: '6px', marginBottom: '10px' }}>
        <div style={{ width: '22mm', flexShrink: 0, textAlign: 'center' }}>
          <img src="/logo.png" alt="MSG Logo" style={{ width: '18mm', height: '18mm', objectFit: 'contain', display: 'block', margin: '0 auto' }} />
        </div>
        <div style={{ flex: 1, textAlign: 'center', padding: '0 4px' }}>
          <div style={{ fontSize: '14px', fontWeight: 900, color: '#1b5e20', letterSpacing: '0.5px' }}>
            MSG NATUROPATHY CENTER
          </div>
          <div style={{ fontSize: '9px', fontWeight: 700, color: '#2e7d32', marginTop: '1px' }}>
            (MANAGED BY ARZ UNIQUE ENTERPRISES LIMITED)
          </div>
          <div style={{ fontSize: '9px', color: '#444', marginTop: '2px' }}>Sirsa, Haryana</div>
          <div style={{ fontSize: '9px', color: '#444' }}>
            +91 7082999551 / 7082999351 &nbsp;|&nbsp; msgelite7wonders@gmail.com
          </div>
          <div style={{ fontSize: '12px', fontWeight: 700, marginTop: '5px', letterSpacing: '1px', color: '#333' }}>
            PAYMENT RECEIPT
          </div>
        </div>
        <div style={{ width: '22mm', flexShrink: 0, textAlign: 'center' }}>
          <div style={{
            width: '18mm', height: '18mm', borderRadius: '50%', background: '#fff9e6',
            border: '2px solid #e65100', margin: '0 auto', display: 'flex',
            alignItems: 'center', justifyContent: 'center', fontSize: '6px',
            fontWeight: 900, color: '#bf360c', lineHeight: 1.3, textAlign: 'center'
          }}>DERA<br />SACHA<br />SAUDA</div>
        </div>
      </div>

      {/* Receipt & Bill Info */}
      <div style={styles.section}>
        <div style={styles.row}>
          <span style={styles.label}>Receipt No.:</span>
          <span style={styles.value}><strong>{payment.payment_number}</strong></span>
        </div>
        <div style={styles.row}>
          <span style={styles.label}>Invoice No.:</span>
          <span style={styles.value}>{bill.bill_number}</span>
        </div>
        <div style={styles.row}>
          <span style={styles.label}>Payment Date:</span>
          <span style={styles.value}>
            {new Date(payment.payment_date).toLocaleDateString('en-IN')} &nbsp;
            {new Date(payment.payment_date).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })}
          </span>
        </div>
        <div style={styles.row}>
          <span style={styles.label}>Payment Method:</span>
          <span style={styles.value}>{payment.payment_method?.toUpperCase()}</span>
        </div>
        {payment.transaction_id && (
          <div style={styles.row}>
            <span style={styles.label}>Transaction ID:</span>
            <span style={styles.value}>{payment.transaction_id}</span>
          </div>
        )}
      </div>

      <div style={styles.divider} />

      {/* Patient Info */}
      <div style={styles.section}>
        <div style={styles.row}>
          <span style={styles.label}>Patient Name:</span>
          <span style={styles.value}>{bill.first_name} {bill.last_name}</span>
        </div>
        <div style={styles.row}>
          <span style={styles.label}>UHID:</span>
          <span style={styles.value}>{bill.patient_code}</span>
        </div>
        {bill.phone && (
          <div style={styles.row}>
            <span style={styles.label}>Phone:</span>
            <span style={styles.value}>{bill.phone}</span>
          </div>
        )}
        <div style={styles.row}>
          <span style={styles.label}>Bill Type:</span>
          <span style={styles.value}>
            {bill.bill_type === 'day_care' ? 'Day Care' : bill.bill_type?.toUpperCase()}
          </span>
        </div>
      </div>

      <div style={styles.divider} />

      {/* Bill Summary */}
      <div style={styles.section}>
        <div style={styles.row}>
          <span style={styles.label}>Invoice Total:</span>
          <span style={styles.value}>₹{parseFloat(bill.total_amount).toFixed(2)}</span>
        </div>
        <div style={styles.row}>
          <span style={styles.label}>Previously Paid:</span>
          <span style={styles.value}>₹{(parseFloat(bill.amount_paid) - parseFloat(payment.amount)).toFixed(2)}</span>
        </div>
      </div>

      {/* Payment Amount */}
      <div style={styles.amountBox}>
        <div style={styles.amountLabel}>AMOUNT RECEIVED</div>
        <div style={styles.amountValue}>₹{parseFloat(payment.amount).toFixed(2)}</div>
      </div>

      {/* Balance */}
      {!isPaidFull && (
        <div style={styles.balanceBox}>
          <div style={styles.balanceLabel}>BALANCE DUE</div>
          <div style={styles.balanceValue}>₹{balanceDue.toFixed(2)}</div>
        </div>
      )}
      {isPaidFull && (
        <div style={{ ...styles.balanceBox, background: '#e8f5e9', border: '1px solid #4caf50' }}>
          <div style={{ ...styles.balanceLabel, color: '#388e3c' }}>FULLY PAID — SETTLED</div>
        </div>
      )}

      {payment.notes && (
        <>
          <div style={styles.divider} />
          <div style={{ fontSize: '10px', color: '#555' }}>
            <strong>Note:</strong> {payment.notes}
          </div>
        </>
      )}

      {/* Received by */}
      <div style={styles.divider} />
      <div style={styles.row}>
        <span style={styles.label}>Received By:</span>
        <span style={styles.value}>{payment.received_by_name}</span>
      </div>

      {/* Footer */}
      <div style={styles.footer}>
        <p>Thank you for your payment. This is a computer-generated receipt.</p>
        <p>MSG Naturopathy Center — Sirsa, Haryana</p>
      </div>
    </div>
  );
}

export default PaymentReceipt;
